/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_Dell_SupportInputs */

const en_colleague_action_dell_support = /** @type {(inputs: Colleague_Action_Dell_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell Tech Support`)
};

const ja_colleague_action_dell_support = /** @type {(inputs: Colleague_Action_Dell_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell テクニカルサポート`)
};

const fr_colleague_action_dell_support = /** @type {(inputs: Colleague_Action_Dell_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support technique Dell`)
};

const de_colleague_action_dell_support = /** @type {(inputs: Colleague_Action_Dell_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dell Tech Support`)
};

/**
* | output |
* | --- |
* | "Dell Tech Support" |
*
* @param {Colleague_Action_Dell_SupportInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_dell_support = /** @type {((inputs?: Colleague_Action_Dell_SupportInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_Dell_SupportInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_dell_support(inputs)
	if (locale === "ja") return ja_colleague_action_dell_support(inputs)
	if (locale === "fr") return fr_colleague_action_dell_support(inputs)
	return de_colleague_action_dell_support(inputs)
});